import React from 'react';
import { MiniWizardView } from './core/MiniWizardView';
import { useMiniWizard } from './core/useMiniWizard';
import { Route } from 'react-router';

export const MiniWizardRouteHandler: React.FC = () => {
    return (
        <Route path="/q/:wizardKey" render={routeParams => (
            <MiniWizardPage key={routeParams.match.params.wizardKey} wizardKey={routeParams.match.params.wizardKey} />
        )} />
    );
};

export const MiniWizardPage: React.FC<{ wizardKey: string; }> = ({ wizardKey }) => {
    const miniWizardViewModel = useMiniWizard(wizardKey);

    if (!miniWizardViewModel){
        return null;
    }

    return (
        <MiniWizardView key={wizardKey} miniWizard={miniWizardViewModel} />
    );
};
